import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

function useActiveMenu() {
	const location = useLocation();
	const [active, setActive] = useState(null);

	useEffect(() => {
		const path = location.pathname;
		switch (path) {
			case '/loans':
				setActive('loans');
				break;
			case '/payments':
				setActive('payments');
				break;
			case '/':
				setActive('dashboard');
				break;
			case '/people':
				setActive('people');
				break;
			case '/help':
				setActive('help');
				break;
			case '/profile':
				setActive('profile');
				break;
			default:
				setActive('none');
				break;
		}
	}, [location, active]);

	return { active, setActive };
}

export default useActiveMenu;
